import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@/lib/api/errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      // A 4xx won't change on a retry; a network blip or 5xx might.
      retry: (failures, error) =>
        failures < 2 && !(isApiError(error) && error.status >= 400 && error.status < 500),
    },
    mutations: { retry: false },
  },
});
